import { ConfirmDialog, useToast } from "@nabble/ui";
import { regenerateRecoveryCodes } from "../../../../api/secondFactors";
import { errorMessage } from "../../../../errors";

/** Confirms replacing the recovery codes; hands the new ones over to be shown once. */
export function RegenerateCodesDialog({
  open,
  onClose,
  onGenerated,
}: {
  open: boolean;
  onClose: () => void;
  onGenerated: (codes: string[]) => void;
}): React.JSX.Element {
  const { show } = useToast();
  return (
    <ConfirmDialog
      open={open}
      tone="warning"
      icon="refresh"
      title="Generate new codes"
      description="Your current recovery codes will stop working."
      confirmLabel="Generate codes"
      onClose={onClose}
      onConfirm={async () => {
        try {
          const data = await regenerateRecoveryCodes();
          onGenerated(data.recoveryCodes);
        } catch (err) {
          show({ title: "We couldn't generate the codes", text: errorMessage(err, "Please try again."), tone: "danger" });
        }
      }}
    />
  );
}
